import { useCallback } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useFormatter } from 'js/hooks/useFormatter';

import * as Types from '../types';

export const useGetBalance = () => {
    const { balances = {} } = useUserSelector(prop('balance')) || {};
    const formatter = useFormatter();

    return useCallback((type: Types.TBalanceType): string | null => {
        const balance = balances[type];

        if (!balance) {
            return null;
        }

        const { amount = 0, currencyCode } = balance;

        return currencyCode === 'XXX'
            ? `${amount}`
            : formatter.formatCurrency(amount, { currencyCode });
    }, [balances, formatter]);
};
